<div class="picklist-item-details__wrapper">
  <mat-dialog-content class="mat-typography">
    <h4>
      SKU: <b>{{ item.internalSku }}</b>
    </h4>
    <h4>
      Product Name: <b>{{ item.productName }}</b>
    </h4>
    <p>{{ item.productDescription | htmlSanitizer }}</p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Close</button>
  </mat-dialog-actions>
</div>
